// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import { organizationStatus, type default as OrganizationStatus } from './OrganizationStatus';
import { Settings, GoogleIntegration, SoftLedger, SolarNetworkCredential } from '../types/organizationJsonTypes';
import type { ColumnType, Selectable, Insertable, Updateable } from 'kysely';
import { z } from 'zod';

/** Identifier type for public.organization */
export type OrganizationId = string & { __brand: 'OrganizationId' };

/** Represents the table public.organization */
export default interface OrganizationTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<OrganizationId, OrganizationId, OrganizationId>;

  /** Database type: pg_catalog.text */
  name: ColumnType<string, string, string>;

  /** Database type: pg_catalog.text */
  slug: ColumnType<string, string, string>;

  /** Database type: pg_catalog.text */
  domain: ColumnType<string, string, string>;

  /** Database type: public.organization_status */
  status: ColumnType<OrganizationStatus, OrganizationStatus | undefined, OrganizationStatus>;

  /** Database type: pg_catalog.text */
  responsiblePerson: ColumnType<string, string, string>;

  /** Database type: pg_catalog.jsonb */
  settings: ColumnType<Settings, Settings, Settings>;

  /** Database type: pg_catalog.jsonb */
  googleIntegration: ColumnType<GoogleIntegration, GoogleIntegration, GoogleIntegration>;

  /** Database type: pg_catalog.jsonb */
  softLedger: ColumnType<SoftLedger, SoftLedger, SoftLedger>;

  /** Database type: pg_catalog.jsonb */
  solarNetworkCredentials: ColumnType<SolarNetworkCredential, SolarNetworkCredential, SolarNetworkCredential>;

  /** Database type: pg_catalog.jsonb */
  dataSharing: ColumnType<unknown, unknown, unknown>;

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>;

  /** Database type: pg_catalog.timestamptz */
  updatedAt: ColumnType<Date, Date | string | undefined, Date | string>;

  /** Database type: pg_catalog.text */
  jiraTicket: ColumnType<string | null, string | null, string | null>;

  /** Database type: pg_catalog.text */
  lastUpdatedBy: ColumnType<string, string, string>;

  /** Database type: pg_catalog.bool */
  nextAccess: ColumnType<boolean, boolean | undefined, boolean>;
}

export const organizationId = z.string();

export const organization = z.object({
  id: organizationId,
  name: z.string(),
  slug: z.string(),
  domain: z.string(),
  status: organizationStatus,
  responsible_person: z.string(),
  settings: z.unknown(),
  google_integration: z.unknown(),
  soft_ledger: z.unknown(),
  solar_network_credentials: z.unknown(),
  data_sharing: z.unknown(),
  created_at: z.date(),
  updated_at: z.date(),
  jira_ticket: z.string().nullable(),
  last_updated_by: z.string(),
  next_access: z.boolean(),
});

export const organizationInitializer = z.object({
  id: organizationId,
  name: z.string(),
  slug: z.string(),
  domain: z.string(),
  status: organizationStatus.optional(),
  responsible_person: z.string(),
  settings: z.unknown(),
  google_integration: z.unknown(),
  soft_ledger: z.unknown(),
  solar_network_credentials: z.unknown(),
  data_sharing: z.unknown(),
  created_at: z.date().optional(),
  updated_at: z.date().optional(),
  jira_ticket: z.string().optional().nullable(),
  last_updated_by: z.string(),
  next_access: z.boolean().optional(),
});

export const organizationMutator = z.object({
  id: organizationId.optional(),
  name: z.string().optional(),
  slug: z.string().optional(),
  domain: z.string().optional(),
  status: organizationStatus.optional(),
  responsible_person: z.string().optional(),
  settings: z.unknown().optional(),
  google_integration: z.unknown().optional(),
  soft_ledger: z.unknown().optional(),
  solar_network_credentials: z.unknown().optional(),
  data_sharing: z.unknown().optional(),
  created_at: z.date().optional(),
  updated_at: z.date().optional(),
  jira_ticket: z.string().optional().nullable(),
  last_updated_by: z.string().optional(),
  next_access: z.boolean().optional(),
});

export type Organization = Selectable<OrganizationTable>;

export type NewOrganization = Insertable<OrganizationTable>;

export type OrganizationUpdate = Updateable<OrganizationTable>;
